<div class="tiv-wrapper">
  <div
    *ngFor="let item of table | slice : 0 : showOnly"
    class="table-container mb-2"
  >
    <h3 class="table-title">{{ item.title }}</h3>
    <div class="table-responsive">
      <ng2-smart-table [settings]="item.settings" [source]="item.source">
      </ng2-smart-table>
    </div>
  </div>
</div>
